<template>
  <b-card-actions class="text-center">
    <b-avatar
      class="mb-1"
      :variant="`light-${color}`"
      size="45"
    >
      <feather-icon
        size="21"
        :icon="icon"
      />
    </b-avatar>
    <div class="truncate text-center">
      <p class="font-weight-bold">{{ statisticTitle }}</p>
      <h2 class="mb-25 font-weight-bolder" style="font-family: 'Montserrat'" >
        {{ statistic }}
      </h2>
    </div>
  </b-card-actions>
</template>

<script>
 
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
export default {

  components: {
    
    BCardActions
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
    statistic: {
      type: [Number, String],
      required: true,
    },
    statisticTitle: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'primary',
    },
  },
}
</script>
